<script>

const banksData = [
  {
    value: 10,
    label: 'לאומי',
  },
  {
    value: 11,
    label: 'דיסקונט',
  },
  {
    value: 12,
    label: 'הפועלים',
  },
  {
    value: 14,
    label: 'אוצר החייל',
  },
  {
    value: 17,
    label: 'מרכנתיל',
  },
  {
    value: 20,
    label: 'מזרחי',
  },
  {
    value: 26,
    label: 'יובנק',
  },
  {
    value: 31,
    label: 'הבינלאומי',
  },
  {
    value: 52,
    label: 'אגודת ישראל',
  },
  {
    value: 46,
    label: 'מסד',
  },
  {
    value: 4,
    label: 'יהב',
  },
];

export default {
  name: 'Banks',
  computed: {
    banks() {
      return banksData.map(bank => {
        return { value: bank.value, label: `${bank.label} - ${bank.value}` };
      });
    },
  },
};
</script>
